import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import {  Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import BackgroundTheme from "../../../Common/P2P/Header/BackgroundTheme";
import AdharCardForm from "./AdharCardForm";
import AdharSelfyForm from "./AdharSelfyForm";
import WebCam from "./WebCam";
import { getAdharcardImage, getAdharcardImageReset, getAdharcardReq } from "./adharCardActions";

const AdharCardKyc = () => {
  const dispatch = useDispatch();
  
  const {adharcardImage,adharcardData,adharcardError} = useSelector(
    (state: any) => state.adharCard
  );
  const history = useHistory();
  const [disable, setDisable] = useState(true);
  const [showWebCam, setShowWebcam] = useState(false);
  const [kycDocument, setKycDocument] = useState(false);
  const [facingModeCamera , setFacingModeCamera] = useState(false);
  
  useEffect(()=> {
    if(adharcardData || adharcardError){
      if(adharcardData && adharcardData?.status){
        // history.push("/p2p/infoConfirmP2p");
      }
    }
  },[adharcardData,adharcardError])
  const webcamRef = useRef<any>(null);
  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    dispatch(getAdharcardImage(imageSrc))
    setShowWebcam(false);
    setDisable(false);
  }, [webcamRef]);

  const handleRetake = () => {
    dispatch(getAdharcardImageReset())
    setKycDocument(false);
    setShowWebcam(true);
  };

  const initialValues = {
    adharCard: "",
  };

  const validationSchema = () =>
    Yup.object().shape({
      adharCard: Yup.string().required("*Required"),
    });

  const onSubmitHandle = (value: any) => {
    dispatch(getAdharcardReq(value))
  };

  const onChangeField = () => {};

  const handleContinue = () => {
    setKycDocument(true);
  };
  const handleImageClick = () => {
    setShowWebcam(true);
  };

  const handleCameraFlip = () => {
    setFacingModeCamera(!facingModeCamera)
  }
  return (
    <>
      <BackgroundTheme>
        <Box className="kycInfo">
          <Typography style={{ marginBottom: "18px" }}>
            <strong>Live Aadhar Card</strong>
          </Typography>
          <Typography className="fs-14" style={{ marginBottom: "14px" }}>
            This live KYC requires your original{" "}
            <span className="fw-700">Aadhar Card</span> photo.
          </Typography>
          <Typography className="fs-12">
            Keep it handy and proceed forward.
          </Typography>
          {kycDocument ? (
            <AdharCardForm
              adharcardImage={adharcardImage}
              handleRetake={handleRetake}
              initialValues={initialValues}
              onSubmitHandle={onSubmitHandle}
              validationSchema={validationSchema}
              onChangeField={onChangeField}
              adharcardError={adharcardError}
            />
          ) : (
            <>
              {showWebCam ? (
                <WebCam 
                capture={capture} 
                webcamRef={webcamRef} 
                handleCameraFlip={handleCameraFlip}
                facingModeCamera={facingModeCamera}/>
              ) : (
                <AdharSelfyForm
                  adharcardImage={adharcardImage}
                  handleContinue={handleContinue}
                  disable={disable}
                  handleImageClick={handleImageClick}
                />
              )}
            </>
          )}
        </Box>
      </BackgroundTheme>
    </>
  );
};

export default AdharCardKyc;
